import { TCompanyAffiliateFirmResponse } from '@commenda/types';
import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';

export function useCompanyAffiliateFirm(companyId: number | null) {
  const {
    data,
    error,
    isLoading,
    mutate,
  }: {
    data?: TCompanyAffiliateFirmResponse;
    error?: unknown;
    isLoading: boolean;
    mutate: KeyedMutator<unknown>;
  } = useSWR(
    companyId ? `affiliate-firms/by-company/${companyId}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data,
    error,
    isLoading,
    mutate,
  };
}
